import { IconProps } from "../../../types/style";

const AuthorizedSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7799 5.37003L10.0999 4.58003C9.96994 4.43003 9.86494 4.15003 9.86494 3.95003V3.10003C9.86494 2.57003 9.42994 2.13503 8.89994 2.13503H8.04994C7.85494 2.13503 7.56994 2.03003 7.41994 1.90003L6.62994 1.22003C6.28494 0.925029 5.71994 0.925029 5.36994 1.22003L4.58494 1.90503C4.43494 2.03003 4.14994 2.13503 3.95494 2.13503H3.08994C2.55994 2.13503 2.12494 2.57003 2.12494 3.10003V3.95503C2.12494 4.15003 2.01994 4.43003 1.89494 4.58003L1.21994 5.37503C0.929941 5.72003 0.929941 6.28003 1.21994 6.62503L1.89494 7.42003C2.01994 7.57003 2.12494 7.85003 2.12494 8.04503V8.90003C2.12494 9.43003 2.55994 9.86503 3.08994 9.86503H3.95494C4.14994 9.86503 4.43494 9.97003 4.58494 10.1L5.37494 10.78C5.71994 11.075 6.28494 11.075 6.63494 10.78L7.42494 10.1C7.57494 9.97003 7.85494 9.86503 8.05494 9.86503H8.90494C9.43494 9.86503 9.86994 9.43003 9.86994 8.90003V8.05003C9.86994 7.85503 9.97494 7.57003 10.1049 7.42003L10.7849 6.63003C11.0749 6.28503 11.0749 5.71503 10.7799 5.37003ZM8.07994 5.05503L5.66494 7.47003C5.59494 7.54003 5.49994 7.58003 5.39994 7.58003C5.29994 7.58003 5.20494 7.54003 5.13494 7.47003L3.92494 6.26003C3.77994 6.11503 3.77994 5.87503 3.92494 5.73003C4.06994 5.58503 4.30994 5.58503 4.45494 5.73003L5.39994 6.67503L7.54994 4.52503C7.69494 4.38003 7.93494 4.38003 8.07994 4.52503C8.22494 4.67003 8.22494 4.91003 8.07994 5.05503Z"
          fill="#4CAF50"
        />
      </svg>
    </div>
  );
};
export default AuthorizedSVG;
